module.exports = __webpack_public_path__ + "static/media/chat-bubble-dark-off.036f4900.svg";